import type { FunctionComponent } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"

import { UnderlineShape } from "@/modules/brand/components/UnderlineShape/UnderlineShape"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"

import styles from "./JobAdsTitle.module.css"

export const JOB_ADS_TITLE_ANCHOR_ID = "jobAdsTitle"

export const JobAdsTitle: FunctionComponent = () => {
  const { t } = useTranslation(["companies_client"])
  const { dataJobAds } = useJobAdsFromAlgolia()

  const count = dataJobAds?.totalSize || 0

  return (
    <Heading
      as="h2"
      variant="title2"
      weight="bold"
      className={styles.main}
      id={JOB_ADS_TITLE_ANCHOR_ID}
      data-testid="company_job_ads_title"
    >
      <UnderlineShape text={`${count}`} />
      {` ${t("companies_client.jobAds.list.title", { count })}`}
    </Heading>
  )
}
